import { render, staticRenderFns } from "./cybImg.vue?vue&type=template&id=6455681a&scoped=true"
import script from "./cybImg.vue?vue&type=script&lang=js"
export * from "./cybImg.vue?vue&type=script&lang=js"
import style0 from "./cybImg.vue?vue&type=style&index=0&id=6455681a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455681a",
  null
  
)

export default component.exports